export const AZURE_MEDIA_PLAYER_STYLES =
  'amp.azure.net/libs/amp/2.2.4/skins/amp-flush/azuremediaplayer.min.css'
export const AZURE_MEDIA_PLAYER_SCRIPT =
  'amp.azure.net/libs/amp/2.2.4/azuremediaplayer.min.js'

export const preRollSourceTypes = {
  HOUSE: 'House',
  PAID: 'Paid',
}

export const preRollSourceUriMap = {
  [preRollSourceTypes.HOUSE]:
    '//pubads.g.doubleclick.net/gampad/ads?correlator=[placeholder]&iu=/13970653/CH_3_Video_Testing&env=vp&gdfp_req=1&output=vast&sz=640x480&description_url=http%3A%2F%2Fpsoriasis.org&tfcd=1&npa=0&vpmute=0&vpa=0&vad_format=linear&url=http%3A%2F%2Fpsoriasis.org&vpos=preroll&unviewed_position_start=1',
  [preRollSourceTypes.PAID]:
    '//pubads.g.doubleclick.net/gampad/ads?iu=/13970653/video_preroll&description_url=http%3A%2F%2Fwww.psoriasis.org%2Fnpf-videos%2Four-mission&tfcd=0&npa=0&sz=400x300%7C640x480&min_ad_duration=14000&max_ad_duration=60000&gdfp_req=1&output=vast&unviewed_position_start=1&env=vp&correlator=[placeholder]&nofb=1&vpmute=0&vpa=1&vad_format=linear&url=http%3A%2F%2Fwww.psoriasis.org%2Fnpf-videos%2Four-mission&vpos=preroll',
}

export const videoIdRegex = url => {
  if (!url) {
    throw new Error('no url was passed')
  }

  // eslint-disable-next-line no-useless-escape
  const regExp =
    /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/
  const match = url.match(regExp)

  return match && match[7].length === 11 ? match[7] : false
}
